module.exports = __webpack_public_path__ + "img/astrid.a0db2ecd.png";